export const STANDARD_VAT_FACTOR = 1.25;

export const calculateSalesCoverage = (salesFactor: number) => {
  return ((100 * (salesFactor - 1)) / salesFactor).toFixed(2);
};

export function calculateToPercentage(number: number) {
  const decimalPart = number - 1;
  const percentage = decimalPart * 100;

  return percentage;
}

export function calculateFromPercentage(percentageValue: number) {
  return percentageValue / 100 + 1;
}

const stripFloatNoise = (value: number) => Math.round(value * 1e6) / 1e6;

export const discountPercentFromFactor = (factor: number) => stripFloatNoise((1 - factor) * 100);

export const factorFromDiscountPercent = (discountPercent: number) =>
  stripFloatNoise(1 - discountPercent / 100);

export function calculateVatPrice(
  price: number,
  priceIncludesVat: boolean,
  vatFactor = STANDARD_VAT_FACTOR
) {
  return priceIncludesVat ? price * vatFactor : price;
}

export function calculatePriceWithoutVat(
  price: number,
  priceIncludesVat: boolean,
  vatFactor = STANDARD_VAT_FACTOR
) {
  return priceIncludesVat ? price / vatFactor : price;
}

export function calculateCoverageFromSalesFactor(salesFactor: number) {
  return 100 * ((salesFactor - 1) / salesFactor);
}

export function calculateSalesFactorFromDG(DG: number) {
  return 1 / (1 - DG / 100);
}

export function calculateNewPriceFromDG(costPrice: number, DG: number) {
  return costPrice * calculateSalesFactorFromDG(DG);
}

export function calculateNewSalesFactor(costPrice: number, newPrice: number, vatFactor?: number) {
  return newPrice / (vatFactor || 1) / costPrice;
}

export function calculateSalesCoverageFromCostAndSalesPrice(
  costPrice: number,
  salesPrice: number,
  vatFactor?: number
) {
  const salesFactor = calculateNewSalesFactor(costPrice, salesPrice, vatFactor);
  return calculateCoverageFromSalesFactor(salesFactor);
}

export function roundToMaxDecimalCount(number: number, decimalCount: number) {
  return Number(number.toFixed(decimalCount));
}

export function calculatePercentChange(currentPrice: number, futurePrice: number) {
  return ((futurePrice - currentPrice) / currentPrice) * 100;
}
